import * as React from "react";

import type { AppButtonProps } from "@1js/acui-button";
import { UILocation } from "@1js/acui-common";

import { RibbonButton } from "../Controls";

export function getDefaultRibbonButtonRenderer() {
  return (props: AppButtonProps) => (
    <RibbonButton {...props} location={props.location || UILocation.Ribbon} />
  );
}
